export const SET_LOGIN_DETAILS = "setLoginDetails";
export const SET_LOGOUT_DETAILS = "setLogoutDetails";
